import React from 'react';
import styles from './LoginButton.module.scss';
import Loader from 'component/atom/loader/Loader';

const LoginButton = ({
  type = 'submit',
  isLoading,
  disabled,
  className,
  label,
}) => {
  const isDisabled = disabled ?? isLoading;
  return (
    <button
      type={type}
      className={`${styles.btn} ${isLoading ? styles.loading : ''} ${className || ''}`}
      disabled={isDisabled}
    >
      {isLoading ? (
        <div className={styles.inlineLoader}>
          <span className={styles.text}>Signing in...</span>
        </div>
      ) : (
        <span className={styles.text}>{label}</span>
      )}
    </button>
  );
};

export default LoginButton;
